import React from 'react';
import { NNSelect } from '../ui';
import { useConsumerUnit } from '../../contexts/ConsumerUnitContext';

/**
 * Unit scope selector for the Manager role.
 * Renders in the global Header (variant="header") or inline (default).
 * Hidden when fixed (Director drill-down). Shows label if single unit.
 */
function UnitSelector({ variant }) {
  const { units, selectedUnitId, setSelectedUnitId, isFixed, singleUnit } = useConsumerUnit();

  if (isFixed) return null;

  if (singleUnit) {
    const unit = units[0];
    if (!unit) return null;
    return (
      <span className={
        variant === 'header'
          ? 'text-body-sm text-text-primary font-medium px-2'
          : 'text-body-sm text-text-dark font-medium'
      }>
        {unit.name}
      </span>
    );
  }

  const options = units.map((u) => ({ value: u.id, label: u.name }));

  return (
    <NNSelect
      value={selectedUnitId}
      onChange={setSelectedUnitId}
      options={options}
      variant={variant === 'header' ? 'header' : 'default'}
    />
  );
}

export default UnitSelector;
